import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import jwt_decode from "jwt-decode";
import axios from "axios";
import logo from "../../../../assets/images/logowhite.png";
import sidelogo from "../../../../assets/images/newname.png";

import {
  NuInput,
  NuInputLogin,
  NuInputToggle,
} from "../../../../Components/Utils/Input";
import { useToast } from "../../../../Components/Others/ToastServices";
import CryptoJS from "crypto-js";
import ChangePassword from "./changePassword";
import "../../../../App.css";
import { GetDashboardRole } from "../../../../Components/Utils/roles";

axios.defaults.baseURL = window.WEB_APP_API_URL;
function AnotherLogin() {
  const toast = useToast();
  const [showForgetPassword, setShowForgetPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const handleForgetPasswordClick = () => {
    setShowForgetPassword(true);
  };
  const handleCloseModal = () => {
    setShowForgetPassword(false);
  };
  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
  });

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
      });
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (
      localStorage.getItem("nEkOtReSuEdArT") &&
      localStorage.getItem("sLiAtEdReSuEdArT") &&
      localStorage.getItem("sSeCcArEsUeDaRt")
    ) {
      window.location.replace(
        GetDashboardRole("")
          ? "/dashboard"
          : GetDashboardRole("sales")
          ? "/dashboard/sales"
          : GetDashboardRole("procurement")
          ? "/dashboard/procurement"
          : GetDashboardRole("store")
          ? "/dashboard/stores"
          : "#"
      );
    }
  }, []);

  const encryptData = async (data, location) => {
    let Test = JSON.stringify(data);
    const Value = CryptoJS.AES.encrypt(
      Test,
      process.env.REACT_APP_ACCESS_KEY
    ).toString();
    localStorage.setItem(location, Value);
    // console.log('EnC',Value)
  };

  const [createNew, setCreateNew] = useState({
    email: "",
    password: "",
  });
  const formik = useFormik({
    initialValues: createNew,
    validateOnChange: false,
    validationSchema: yup.object({
      email: yup.string().required("Email is Required"),
      password: yup.string().required("Password is Required"),
    }),
    onSubmit: async (value) => {
      setIsLoading(true);
      await axios
        .post("/auth/login", value)
        .then(async (res) => {
          if (res.data.status) {
            setIsLoading(false);
            let userToken = res?.data?.token;
            await encryptData(userToken, "nEkOtReSuEdArT");
            let decodeToken = jwt_decode(res?.data?.token);
            await encryptData(decodeToken, "sLiAtEdReSuEdArT");
            let permissions = res?.data?.permissions;
            await encryptData(permissions, "sSeCcArEsUeDaRt");
            toast.open({
              message: "Login Successful",
              description: res.data.msg || "You have successfully logged in.",
              type: "success",
            });
            window.location.replace(
              GetDashboardRole("")
                ? "/dashboard"
                : GetDashboardRole("sales")
                ? "/dashboard/sales"
                : GetDashboardRole("procurement")
                ? "/dashboard/procurement"
                : GetDashboardRole("store")
                ? "/dashboard/stores"
                : "/dashboard"
            );
          } else {
            setIsLoading(false);
                toast.open({
                message: "Login Unsuccessful",
                description: res.data.msg || "Login failed.",
                type: "error",
              })
           
          }
        })
        .catch((err) => {
          setIsLoading(false);
          console.log("Login failed or a network error occurred.");
          
          toast.open({
            message: "Login Unsuccessful",
            description:err?.res.data.msg ||"Login failed or a network error occurred.",
            type: "error",
          });
        });
    },
  });
  const [companyLog, setCompanyLog] = useState("");

  function getLog() {
    axios
      .get("/company-info/company-logo")
      .then((res) => {
        console.log("Logdddd", res?.data?.data?.file);
        res?.data?.data?.file && setCompanyLog(res.data.data?.file);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  useEffect(() => {
    getLog();
  }, []);

  return (
     <div className="w-full min-h-screen login-image flex flex-col md:flex-row items-center justify-center relative gap-4">
   {/* <div className="text-outside hidden md:block">
    <h1 className="text-lg font-bold mb-4">nuservice</h1>
    <div className="space-y-1 text-top mb-6 ">
      <p className="text-3xl font-extrabold ">Simplify </p>
      <p className="text-3xl font-extrabold "> Inspections.</p>

      <p className="text-3xl font-extrabold ">Elevate</p>
      <p className="text-3xl font-extrabold ">Performance.</p>
      <p className="text-sm mt-2">Built for quality-driven teams.</p>

    </div>
    </div> */}
      {/* <div className="text-outside hidden md:block">
        <h1 className="lg:text-[100px] text-[70px] font-bold mb-4">nuserv</h1>
      </div>
      <div className="space-y-1  my-6 text-top hidden md:block ">
        <p className="lg:text-3xl text-2xl font-extrabold ">
          Simplify Inspections.
        </p>
        <p className="lg:text-3xl text-2xl font-extrabold ">
          Elevate Performance.
        </p>
        <p className="text-sm mt-2">Built for quality-driven teams.</p>
      </div> */}

  
  <div className="hidden md:flex justify-end items-center h-[80vh] w-[45%] z-20">
    <div className="flex flex-col justify-center text-white">
      <h1
        className="text-[70px] lg:text-[100px] font-black flex h-28 w-h-28 text-center tracking-wide"
        // style={{
        //   textShadow: `
        //     2px 2px 0 #4b5563,
        //     4px 4px 0 #374151,
        //     6px 6px 5px rgba(55,65,81,0.5)
        //   `
        // }}
      >
                  {/* <img src={logo} alt="logo" className="object-contain w-[90px]" /> */}

                  <img src={sidelogo} alt="logo" className="object-contain w-[270px]" />

      </h1>

      <div className="space-y-3 mb-8 text-left mt-6 ">
        <p
          className="text-2xl lg:text-3xl font-extrabold leading-tight"
          // style={{
          //   textShadow: `
          //     1px 1px 0 #4b5563,
          //     2px 2px 0 #374151,
          //     3px 3px 4px rgba(55,65,81,0.5)
          //   `
          // }}
        >
          Simplify Inspections
        </p>
        <p
          className="text-2xl lg:text-3xl font-extrabold leading-tight"
          // style={{
          //   textShadow: `
          //     1px 1px 0 #4b5563,
          //     2px 2px 0 #374151,
          //     3px 3px 4px rgba(55,65,81,0.5)
          //   `
          // }}
        >
          Elevate Performance
        </p>
        <p
          className="text-base font-light mt-2 opacity-90"
          style={{
            textShadow: `
              1px 1px 0 #4b5563,
              2px 2px 5px rgba(55,65,81,0.4)
            `
          }}
        >
          Built for quality-driven teams
        </p>
      </div>
    </div>
  </div>

   <div className="w-full md:w-[50%] flex items-center justify-center md:justify-start h-auto md:h-[80vh] px-4 z-20">
    <div className="w-full max-w-[350px] md:max-w-[400px] bg-white rounded-2xl p-8 flex flex-col items-center shadow-lg min-h-[65vh]">

{/* <div className="w-full md:w-[50%] flex items-center justify-center md:justify-start h-auto md:h-[80vh] px-4">
  <div className="w-full max-w-[350px] md:max-w-[400px] bg-[#b91c1c]/15 backdrop-blur-sm border border-white border-solid rounded-2xl p-8 flex flex-col items-center shadow-lg min-h-[70vh]"> */}
    
    <div className="w-[120px] h-[120px] flex items-center justify-center mb-1">
      
       {companyLog !== "" && (
          <img src={companyLog} alt="logo" className="object-contain" />
        )}
      </div>

      <p className="text-baseColor-primary font-extrabold text-[24px] mb-1">Login</p>

      <form onSubmit={formik.handleSubmit} className="w-full">
        <NuInputLogin
          type="text"
          label="Email *"
          placeholder="Enter Your Mail"
          formik={formik}
          name="email"
          width="w-full"
          padding=""
                    color = "white"

        />

        <NuInputToggle
          label="Password *"
          placeholder="************"
          formik={formik}
          name="password"
          width="w-full"
          padding=""
                    color = "white"

        />

        <div className="text-right mt-1 mb-4">
          <span
            onClick={handleForgetPasswordClick}
            className="text-sm cursor-pointer "
          >
            Forgot Your Password?{" "}
            <span className="text-baseColor-primary">Reset</span>
          </span>
        </div>

      <div className="flex justify-center">
  <button
    type="submit"
    className={`w-[50%] h-10 rounded-3xl text-white text-sm font-semibold ${
      isLoading ? "cursor-wait bg-[#d0f6f3]" : "cursor-pointer bg-baseColor-primary"
    }`}
  >
    Login
  </button>
</div>


      </form>
    </div>
  </div>

 
  <p className="absolute bottom-2 w-full text-white text-center text-xs italic font-extralight">
    product by numota
  </p>

  {showForgetPassword && <ChangePassword onClose={handleCloseModal} />}
</div>


  );
}
export default AnotherLogin;
